import {
  HIS_ACCOUNTANT,
  HIS_ADMIN,
  HIS_BRANCH_MANAGER,
  HIS_CASHIER,
  HIS_CHIEF_TECHNICIAN,
  HIS_DOCTOR,
  HIS_READ_ONLY,
  HIS_SALES_CONSULTANT,
  HIS_SUPER_ADMIN,
  HIS_TECHNICIAN,
  PathModule,
} from "app/common/LocalConst";
import { EgretLoadable } from "egret";

const TreatmentManagementRouter = {
  path: PathModule.TREATMENT_MANAGEMENT,
  exact: true,
  auth: [
    HIS_ADMIN,
    HIS_DOCTOR,
    HIS_BRANCH_MANAGER,
    HIS_CHIEF_TECHNICIAN,
    HIS_TECHNICIAN,
    HIS_READ_ONLY,
    HIS_CASHIER,
  ],
  children: [
    {
      path: "treatment-list",
      auth: [
        HIS_ADMIN,
        HIS_DOCTOR,
        HIS_BRANCH_MANAGER,
        HIS_TECHNICIAN,
        HIS_CHIEF_TECHNICIAN,
        HIS_READ_ONLY,
      ],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import("app/TreatmentManagement/TreatmentList/TreatmentListIndex"),
      }),
    },
    {
      path: "treatment-list-all",
      auth: [
        HIS_ADMIN,
        HIS_DOCTOR,
        HIS_BRANCH_MANAGER,
        HIS_TECHNICIAN,
        HIS_CHIEF_TECHNICIAN,
        HIS_READ_ONLY,
      ],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/TreatmentManagement/TreatmentListAll/TreatmentListAllIndex"
          ),
      }),
    },
    {
      path: "price-item-report",
      auth: [
        HIS_ADMIN,
        HIS_DOCTOR,
        HIS_BRANCH_MANAGER,
        HIS_TECHNICIAN,
        HIS_CHIEF_TECHNICIAN,
        HIS_READ_ONLY,
      ],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import("app/PatientManagement/ReportPriceItem/ReportPriceItemIndex"),
      }),
    },
    {
      path: "receive-treatment",
      exact: true,
      auth: [
        HIS_ADMIN,
        HIS_BRANCH_MANAGER,
        HIS_DOCTOR,
        HIS_CHIEF_TECHNICIAN,
        HIS_TECHNICIAN,
      ],
      component: EgretLoadable({
        loader: () =>
          import(
            "app/TreatmentManagement/ReceiveTreatment/ReceiveTreatmentIndex"
          ),
      }),
    },
    {
      path: "treatment-results-detail/:id",
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/TreatmentManagement/TreatmentResultsDetail/TreatmentResultsDetail"
          ),
      }),
    },
    {
      path: "treatment-update-tour-and-image",
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/TreatmentManagement/TreatmentUpdateImageAndTour/TreatmentPatientInfoIndex"
          ),
      }),
    },
    {
      path: "treatment-update-results-detail/:id",
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/TreatmentManagement/TreatmentResultsInfoDetail/TreatmentResultsInfoDetailIndex"
          ),
      }),
    },
    {
      path: "uncompleted-register-services-report",
      auth: [
        HIS_ADMIN,
        HIS_SUPER_ADMIN,
        HIS_BRANCH_MANAGER,
        HIS_CHIEF_TECHNICIAN,
        HIS_READ_ONLY,
      ],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/TreatmentManagement/UncompletedServicesReport/UncompletedServicesReportIndex"
          ),
      }),
    },

    {
      path: "treatment-list-appointment",
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/TreatmentManagement/TreatmentAppoiontment/TreamentAppoiontmentIndex"
          ),
      }),
    },

    {
      path: "treatment-patient-info-detail",
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/TreatmentManagement/TreamentInfoDetail/TreamentInfoDetailIndex"
          ),
      }),
    },

    {
      path: "medical-equipment-usage-report",
      auth: [
        HIS_ADMIN,
        HIS_BRANCH_MANAGER,
        HIS_CHIEF_TECHNICIAN,
        HIS_SUPER_ADMIN,
        HIS_DOCTOR,
        HIS_TECHNICIAN,
        HIS_READ_ONLY,
      ],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/TreatmentManagement/MedicalEquipmentUsageReport/MedicalEquipmentUsageReportIndex"
          ),
      }),
    },
    {
      path: "treatment-report",
      auth: [
        HIS_ADMIN,
        HIS_BRANCH_MANAGER,
        HIS_CHIEF_TECHNICIAN,
        HIS_SUPER_ADMIN,
        HIS_DOCTOR,
        HIS_SALES_CONSULTANT,
        HIS_TECHNICIAN,
        HIS_READ_ONLY,
      ],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/TreatmentManagement/TreatmentReport/TreatmentReportIndex"
          ),
      }),
    },
    {
      path: "report-treament-sales-allocation",
      auth: [
        HIS_ADMIN,
        HIS_BRANCH_MANAGER,
        HIS_CHIEF_TECHNICIAN,
        HIS_TECHNICIAN,
        HIS_READ_ONLY,
        HIS_DOCTOR,
      ],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/PatientManagement/ReportSalesAllocation/ReportSalesAllocationIndex"
          ),
      }),
    },
    {
      path: "report-treament-revenue-allocation",
      auth: [
        HIS_ADMIN,
        HIS_BRANCH_MANAGER,
        HIS_CHIEF_TECHNICIAN,
        HIS_TECHNICIAN,
        HIS_READ_ONLY,
      ],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/PatientManagement/ReportRevenueAllocation/ReportRevenueAllocationIndex"
          ),
      }),
    },

    {
      path: "appointment-tracking",
      auth: [
        HIS_ADMIN,
        HIS_BRANCH_MANAGER,
        HIS_CHIEF_TECHNICIAN,
        HIS_TECHNICIAN,
        HIS_DOCTOR,
      ],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/PatientManagement/AppointmentTracking/AppointmentTrackingIndex"
          ),
      }),
    },
    {
      path: "construction-materials-synthesis",
      auth: [HIS_ADMIN, HIS_BRANCH_MANAGER, HIS_CASHIER, HIS_ACCOUNTANT],

      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/TreatmentManagement/ConstructionMaterialsSynthesis/ConstructionMaterialsSynthesisIndex"
          ),
      }),
    },
    {
      path: "report-treament-monney-tour",
      exact: true,
      auth: [
        HIS_DOCTOR,
        HIS_TECHNICIAN,
        HIS_CHIEF_TECHNICIAN,
        HIS_ADMIN,
        HIS_BRANCH_MANAGER,
        HIS_CASHIER,
        HIS_ACCOUNTANT,
      ],
      component: EgretLoadable({
        loader: () =>
          import(
            "app/PatientManagement/ReportMonneyTour/ReportMonneyTourIndex"
          ),
      }),
    },
    {
      path: "embedded-iframe",
      exact: true,
      component: EgretLoadable({
        loader: () => import("app/EmbeddedIFrame/EmbeddedIFrameIndex"),
      }),
    },
  ],
};

export default TreatmentManagementRouter;
